import {
  ADMIN_GET_BILLING_PLANS,
  ADMIN_GET_PROJECTS,
  ADMIN_GET_REALM_BILLING,
  ADMIN_GET_USERS,
  ADMIN_GET_USER_REALMS,
  GET_USER_DISPLAY,
} from "../contants";

const initialState = {
  projectsList: [],
  billingPlans: [],
  realmBilling: [],
  userRealms: [],
  users: [],
  userDisplayCache: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_GET_PROJECTS: {
      return {
        ...state,
        projectsList: action.payload,
      };
    }
    case ADMIN_GET_BILLING_PLANS: {
      return {
        ...state,
        billingPlans: action.payload,
      };
    }
    case ADMIN_GET_REALM_BILLING: {
      return {
        ...state,
        realmBilling: action.payload,
      };
    }
    case ADMIN_GET_USER_REALMS: {
      return {
        ...state,
        userRealms: action.payload,
      };
    }
    case ADMIN_GET_USERS: {
      return {
        ...state,
        users: action.payload,
      };
    }
    case GET_USER_DISPLAY: {
      const user = action.payload;
      return {
        ...state,
        userDisplayCache: {
          ...state.userDisplayCache,
          [user.userId]: user,
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
